import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { v4 as uuid } from 'uuid';
import Header from './components/shared/header';
import Notification from './components/shared/notification';
import { AppRoutes } from './navigation/app-routes';
import { updateUser } from './store/auth/actions';
import { getCookie, removeCookie, setCookie } from './utils/cookie-service';
import Loader from './components/shared/loader';
import routes from './constants/routes';
import { withRouter } from './utils/withRouter';
import JobComments from './components/candidate/job-comments';
import RestrictedAccess from './components/RestrictedAccess';
import CommanFooter from './components/shared/commanFooter';
import { getIpCountry } from './utils/utility';
import { updateSpinner } from './store/global/actions';
import { fetchProfile } from './store/candidate/actions';
import { SocketProvider } from './contexts/SocketContext';

function App(props) {
  /* For Country restriction */
  const [hasAccess, setHasAccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Function to fetch user's country
  const fetchUserCountry = async () => {
    updateSpinner(true);
    setIsLoading(true);
    const data = await getIpCountry();

    setHasAccess(data);
    updateSpinner(false);
    setIsLoading(false);
  };

  let deviceId = getCookie('deviceId');
  if (!deviceId) {
    deviceId = uuid().toString();
    setCookie('deviceId', deviceId);
  }

  const { navigate, auth, location, fetchProfile } = props;

  useEffect(() => {
    const notRedirectROutes = [
      routes.login,
      routes.register,
      routes.forgotPassword,
      routes.thankYou,
      routes.notFound,
      routes.parseResume
    ];
    if (!notRedirectROutes.includes(location.pathname)) {
      setCookie('redirectPath', location.pathname);
    }
    if (auth.isAuthenticated === false) navigate(routes.login);
    if (auth.isAuthenticated === true) fetchProfile();
  }, [auth.isAuthenticated]);

  useEffect(() => {
    if (
      process.env.REACT_APP_ALLOWED_HOST !== window.location.hostname &&
      location.pathname !== routes.notFound
    ) {
      setTimeout(() => {
        navigate(routes.notFound);
      }, 50);
    } else if (location.pathname !== getCookie('prev-path')) removeCookie('filters');
    const isOnboarding = getCookie('onBoarding');
    if (
      !isOnboarding &&
      auth.isAuthenticated &&
      location.search === '' &&
      (location.pathname === routes.login || location.pathname === routes.register)
    ) {
      navigate(routes.dashboard);
    }
    setCookie('prev-path', location.pathname);
  }, [location.pathname, auth.isAuthenticated]);

  const user = getCookie('veriipro-user');
  if (user && !auth.currentUser) {
    const { updateUser } = props;
    updateUser(user);
  }

  /* For Country restriction */
  useEffect(() => {
    fetchUserCountry();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!hasAccess) {
    return (
      <div>
        <Header />
        <RestrictedAccess />
        <CommanFooter />
      </div>
    );
  }
  /* End code  */

  return (
    <div>
      <SocketProvider userId={auth?.currentUser?.id} isAuthenticated={auth?.isAuthenticated}>
        <JobComments />
        <Notification />
        <Loader />
        <Header />
        <div style={{ minHeight: '70vh' }}>
          <AppRoutes />
        </div>
        <CommanFooter />
      </SocketProvider>
    </div>
  );
}

export default connect(
  (state) => ({
    selectedCandidate: state.global.selectedCandidate,
    auth: state.auth
  }),
  { updateUser, fetchProfile }
)(withRouter(App));
